import { EnvelopeIcon } from "@heroicons/react/24/outline"
import { LinkMail } from "@/src/components/core/components/links/LinkMail"
import { LinkTel } from "@/src/components/core/components/links/LinkTel"

export const MarketingPageContact = () => {
  return (
    <section className="rounded-2xl border border-gray-100 p-6">
      <h2 className="flex items-center text-sm font-semibold text-gray-900">
        <EnvelopeIcon className="size-6 flex-none text-gray-400" />
        <span className="ml-3">Kontakt</span>
      </h2>
      <p className="mt-2 text-sm leading-6">
        <strong>FixMyCity GmbH</strong>
        <br />
        <LinkMail>trassenscout@fixmycity.de</LinkMail>
        <br />
        <LinkTel>+49-30 / 549 08 665</LinkTel>
      </p>
    </section>
  )
}
